import React from 'react';
import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import TravelMapShell from './TravelMapShell.jsx';
import { geographyStyles } from './mapGeographyStyles';

const GEO_URL = "https://raw.githubusercontent.com/codeforamerica/click_that_hood/master/public/data/brazil-states.geojson";

const REGIONS = [
    { code: "Acre", name: "Acre" },
    { code: "Alagoas", name: "Alagoas" },
    { code: "Amapá", name: "Amapá" },
    { code: "Amazonas", name: "Amazonas" },
    { code: "Bahia", name: "Bahia" },
    { code: "Ceará", name: "Ceará" },
    { code: "Distrito Federal", name: "Distrito Federal" },
    { code: "Espírito Santo", name: "Espírito Santo" },
    { code: "Goiás", name: "Goiás" },
    { code: "Maranhão", name: "Maranhão" },
    { code: "Mato Grosso", name: "Mato Grosso" },
    { code: "Mato Grosso do Sul", name: "Mato Grosso do Sul" },
    { code: "Minas Gerais", name: "Minas Gerais" },
    { code: "Paraná", name: "Paraná" },
    { code: "Paraíba", name: "Paraíba" },
    { code: "Pará", name: "Pará" },
    { code: "Pernambuco", name: "Pernambuco" },
    { code: "Piauí", name: "Piauí" },
    { code: "Rio de Janeiro", name: "Rio de Janeiro" },
    { code: "Rio Grande do Norte", name: "Rio Grande do Norte" },
    { code: "Rio Grande do Sul", name: "Rio Grande do Sul" },
    { code: "Rondônia", name: "Rondônia" },
    { code: "Roraima", name: "Roraima" },
    { code: "Santa Catarina", name: "Santa Catarina" },
    { code: "Sergipe", name: "Sergipe" },
    { code: "São Paulo", name: "São Paulo" },
    { code: "Tocantins", name: "Tocantins" },
];

const REGION_CODES = REGIONS.map(r => r.code);
const ITEMS = REGIONS.map(r => ({ id: r.code, name: r.name }));

const BrazilMapSection = () => {
    const renderMap = ({ visited, hexColor, toggle }) => (
        <ComposableMap
            projection="geoMercator"
            projectionConfig={{ scale: 700, center: [-52, -14] }}
            width={800}
            height={600}
            style={{ width: '100%', height: 'auto' }}
        >
            <Geographies geography={GEO_URL}>
                {({ geographies }) =>
                    geographies
                        .filter(geo => REGION_CODES.includes(geo.properties.name))
                        .map((geo) => {
                            const code = geo.properties.name;
                            const isVisited = visited.includes(code);
                            return (
                                <Geography
                                    key={geo.rsmKey}
                                    geography={geo}
                                    onClick={() => toggle(code)}
                                    style={geographyStyles(isVisited, hexColor)}
                                />
                            );
                        })
                }
            </Geographies>
        </ComposableMap>
    );

    return (
        <TravelMapShell
            mapType="brazil"
            analyticsLocationType="brazil"
            trackingLabel="Brazil Map"
            storageKey="brazil_map"
            title="🇧🇷 Brazil Travel Map"
            subtitle="Click on Brazilian states you've visited. Or use the checklist below!"
            items={ITEMS}
            noun="States"
            unitLabel="states"
            captionUnit="Brazilian states"
            share={{
                region: 'Brazil',
                fileName: 'visited-brazil-map.png',
                trackId: 'brazil'
            }}
            renderMap={renderMap}
        />
    );
};

export default BrazilMapSection;
